import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const blogData = [
  {
    image: "https://picsum.photos/seed/1/800/400",
    title: "Real Estate Market in 2025",
    description: `The real estate market is evolving rapidly with changing buyer preferences, rising interest in suburban living, and digital platforms influencing decision-making. Developers are now focusing more on smart, sustainable, and community-centric projects to align with this new wave.

Industry experts predict a continued rise in demand for mixed-use developments, co-living spaces, and energy-efficient homes. Staying informed about these trends helps buyers make strategic property investments in the upcoming year.`,
  },
  {
    image: "https://picsum.photos/seed/2/800/400",
    title: "Choosing the Right Builder",
    description: `Selecting the right builder is crucial to ensuring construction quality, timely delivery, and after-sales service. Buyers should assess builder reputation, project history, RERA registration, and customer reviews before signing any agreement.

A trustworthy builder not only adheres to timelines but also delivers consistent value through proper documentation, material quality, and legal compliance—ensuring peace of mind throughout your home-buying journey.`,
  },
  {
    image: "https://picsum.photos/seed/3/800/400",
    title: "Smart Home Investments",
    description: `Smart homes are no longer a luxury but a rising necessity for modern homeowners. Automated lighting, temperature control, security systems, and voice-enabled devices are becoming integral features in new constructions.

Investing in smart technology boosts property value, enhances energy efficiency, and provides greater convenience. It’s a forward-thinking decision that aligns with future living standards and evolving buyer expectations.`,
  },
  {
    image: "https://picsum.photos/seed/4/800/400",
    title: "Luxury vs Budget Homes",
    description: `Luxury homes offer exclusive amenities, premium locations, and enhanced privacy, catering to lifestyle buyers. On the other hand, budget homes prioritize affordability and practicality, making them ideal for first-time buyers and investors.

The right choice depends on your financial goals, family needs, and long-term plans. Evaluate the total cost of ownership, resale potential, and ongoing maintenance to make an informed decision.`,
  },
  {
    image: "https://picsum.photos/seed/5/800/400",
    title: "Property Legal Tips",
    description: `Legal due diligence is the foundation of a secure property transaction. Always verify the title deed, land use permissions, encumbrance certificates, and builder approvals before purchasing any property.

Hiring a legal advisor can safeguard your investment by spotting potential issues in agreements and ownership history. Being proactive with documentation ensures a hassle-free and legally sound buying experience.`,
  },
];


const slideVariants = {
    enter: (direction) => ({
        x: direction > 0 ? 300 : -300,
        opacity: 0,
    }),
    center: {
        x: 0,
        opacity: 1,
    },
    exit: (direction) => ({
        x: direction < 0 ? 300 : -300,
        opacity: 0,
    }),
};

const Blog = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(0); // +1 for next, -1 for prev

    const paginate = (dir) => {
        setDirection(dir);
        setCurrentIndex((prev) => (prev + dir + blogData.length) % blogData.length);
    };

    const current = blogData[currentIndex];
    const prev1 = blogData[(currentIndex - 1 + blogData.length) % blogData.length];
    const prev2 = blogData[(currentIndex - 2 + blogData.length) % blogData.length];

    return (
        <div className="big-house-blog-section">
            <div className="big-house-blog-section-header">
                <h2>Market Trends - Blog</h2>
                <p>Welcome to our Blog – your trusted space for real estate insights, stories, and expert guidance.</p>
            </div>

            <div className="big-house-blog-carousel">
                <div className="big-house-left-blog-section">
                    <img src={prev2.image} alt="Previous 2" className="blog-section-previous-img" />
                    <img src={prev1.image} alt="Previous 1" className="blog-section-previous-img" />
                    <AnimatePresence custom={direction} mode="wait">
                        <motion.img
                            key={current.image}
                            src={current.image}
                            alt={current.title}
                            className="blog-section-current-img"
                            custom={direction}
                            variants={slideVariants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        />
                    </AnimatePresence>
                </div>

                <div className="big-house-right-blog-section">
                    {/* <motion.h3
                        key={current.title}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="blog-section-title"
                    >
                        {current.title}
                    </motion.h3> */}
                    <motion.p
                        key={current.description}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="blog-section-para"
                    >
                        {current.description}
                    </motion.p>

                    <div className="blog-section-chevron-button">
                        <button onClick={() => paginate(-1)}>
                            <ChevronLeft />
                        </button>
                        <button onClick={() => paginate(1)}>
                            <ChevronRight />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;
